// extracted by mini-css-extract-plugin
export default {"buttons":"NewsForm_buttons__-Zesq","left":"NewsForm_left__YDfPY","right":"NewsForm_right__sr2OH","news-properites":"NewsForm_news-properites__Rr6b3"};